module.exports = __webpack_public_path__ + "img/logout.910a788d.svg";